import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import {
  ComputedPairingStatus,
  ComputedRecord,
  ComputedStatus,
} from '../../../../models/states-computed.models'
import { StateMachineSettings } from '../../../../services/touareg-control-state-params.service'
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-state-row',
  templateUrl: './touareg-control-state-row.component.html',
  styleUrls: ['./touareg-control-state-row.component.scss'],
  imports: [Samv2Module],
})
export class TouaregControlStateRowComponent implements OnInit {
  @Output()
  action = new EventEmitter<MouseEvent>()

  @Output()
  openInfo = new EventEmitter<string | number>()

  @Output()
  closeInfo = new EventEmitter<string | number>()

  @Input()
  zone!: 'left' | 'right'

  @Input()
  computedRecord!: ComputedRecord

  @Input()
  showAction!: boolean

  @Input()
  settings!: StateMachineSettings

  @Input()
  open!: boolean

  public icon!: string

  get hasConflict(): boolean {
    return this.computedRecord.computedStatus === ComputedStatus.conflict
  }

  get hasWarning(): boolean {
    return this.computedRecord.computedStatus === ComputedStatus.warning
  }

  get hasPairingConflict(): boolean {
    return (
      this.computedRecord.computedPairingStatus ===
      ComputedPairingStatus.conflict
    )
  }

  get hasAnyConflict(): boolean {
    return this.hasConflict || this.hasPairingConflict
  }

  constructor() {}

  ngOnInit(): void {
    this.icon = this.zone === 'left' ? 'chevron_right' : 'chevron_left'
  }

  public onAction(e: MouseEvent) {
    this.action.emit(e)
  }
}
